import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { BatchService } from '../Services/batch.service';
import { UserService } from '../Services/user.service';
import { HttpClientModule } from '@angular/common/http';
import { NgChartsModule } from 'ng2-charts';
import { ChartType } from 'chart.js';
import { ChartOptions } from 'chart.js';
import { StoreService } from '../Services/store.service';
@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [CommonModule, HttpClientModule, NgChartsModule],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.css',
  providers: [BatchService, UserService,StoreService]
})
export class DashboardComponent {
  userRole: string = '';
  totalStores: number = 0;
  batches: any[] = [];
  users: any[] = [];
  userNameMap: { [key: string]: string } = {};
  loading = true;

  doughnutChartLabels: string[] = ['Completed', 'Partial Complete', 'In Progress', 'Pending', 'Cancelled'];
  doughnutChartData: number[] = [0, 0, 0, 0, 0];
  doughnutChartType: ChartType = 'doughnut';
  doughnutChartColors: string[] = ['#28a745', '#ffc107', '#007bff', '#6c757d', '#d3d3d3'];

  barChartLabels: string[] = [];
  barChartData: number[] = [];
  barChartType: ChartType = 'bar';

  showInProgressList: boolean = false;

  constructor(
    private batchService: BatchService,
    private userService: UserService,
    private storeService: StoreService
  ) {}

  ngOnInit() {
    this.userRole = this.userService.checkRole() ?? '';
    this.fetchDashboardData();
  }

  fetchDashboardData() {
    this.loading = true;
    this.userRole = this.userService.checkRole() ?? '';

    this.batchService.getAllBatch().subscribe((batchData: any) => {
      this.batches = batchData.result || [];

      // this.userService.getUsers().subscribe((userData: any) => {
      //   this.users = userData.result || [];
      //   //this.buildUserMap();
      //   this.loading = false;
      // });
      if (this.userRole === 'StoreAdmin') {
      this.userService.getUsers().subscribe((userData: any) => {
        this.users = userData.result || [];
        this.loading = false;
      });
    }

    if (this.userRole === 'Admin') {
      this.storeService.getStores().subscribe((storeData: any) => {
        this.totalStores = storeData.result?.length || 0;
        this.loading = false;
      });
    }

      this.updateDoughnutChartData();
      this.prepareWeeklyBatchChart();
    });
  }

  buildUserMap() {
    this.users.forEach((user: any) => {
      this.userNameMap[user.userName] = `${user.name}, ${user.email}`;
    });
  }

  getInProgressList(): any[] {
    return this.batches.filter((batch: any) => batch.status === "InProgress");
  }

  updateDoughnutChartData() {
    let countCompleted = 0;
    let countPending = 0;
    let countPartial = 0;
    let countCancelled = 0;
    let countInProgress = 0;

    this.batches.forEach((batch: any) => {
      switch (batch.status) {
        case "Completed": countCompleted++; break;
        case "PartialComplete": countPartial++; break;
        case "InProgress": countInProgress++; break;
        case "Pending": countPending++; break;
        case "Cancelled": countCancelled++; break;
      }
    });

    this.doughnutChartData = [countCompleted, countPartial, countInProgress, countPending, countCancelled];
  }

  prepareWeeklyBatchChart() {
    const now = new Date();
    const days = [];

    for (let i = 6; i >= 0; i--) {
      const date = new Date(now);
      date.setDate(now.getDate() - i);
      const formattedDate = new Intl.DateTimeFormat('en-GB', { day: '2-digit', month: 'short' }).format(date);
      days.push(formattedDate);
    }

    const batchCountMap: { [key: string]: number } = {};
    days.forEach(date => batchCountMap[date] = 0);

    this.batches.forEach((batch: any) => {
      const createdDate = new Date(batch.createdAt);
      const formattedBatchDate = new Intl.DateTimeFormat('en-GB', { day: '2-digit', month: 'short' }).format(createdDate);

      if (batchCountMap.hasOwnProperty(formattedBatchDate)) {
        batchCountMap[formattedBatchDate]++;
      }
    });

    this.barChartLabels = Object.keys(batchCountMap);
    this.barChartData = Object.values(batchCountMap);
  }

  calculatePendingTime(createdAt: string): string {
    const createdDate = new Date(createdAt);
    const now = new Date();
    const diffMs = now.getTime() - createdDate.getTime();
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    return ` (${diffDays} days pending)`;
  }

  getMedicationCount(batch: any): number {
    let total = 0;
    if (batch.prescriptions) {
      batch.prescriptions.forEach((prescription: any) => {
        total += prescription.medications ? prescription.medications.length : 0;
      });
    }
    return total;
  }

  openNav() {
    this.showInProgressList = true;
  }

  closeNav() {
    this.showInProgressList = false;
  }
  chartOptions: ChartOptions = {
    responsive: true,
    plugins: {
      legend: {
        position: 'bottom'
      }
    }
  };
}